<template>
    <div class="layout">
        <slot></slot>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .layout {
        padding-bottom: 40px;
        background-color: #f5f5f5;
    }
</style>